<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-xs-12 text-center">
        <h1>
          <a>
            <img :src="img_url.conasi_logo" width="400px" height="120px">
          </a>
        </h1>
      </div>
      <!-- http://localhost:8080/static/img/conasi_logo.d61a221.png -->
      <!-- <div class="col-xs-6 text-right">
        <h1>{{$t('invoice.invoice')}}</h1>
        <h1>
          <small>
            {{$t('invoice.number')}}:
            <b>#{{invoicedata.invoice_number}}</b>
          </small>
        </h1>
      </div>-->
    </div>

    <div class="box box-primary">
      <div class="row col-sm-12 text-center">
        <img
          :src="imageSrc"
          alt="QR code"
          width="232"
          style="width: 232px;"
          sizes="(max-width: 232px) 100vw, 232px"
        >
        <div class="row text-center" style="border:0px solid red;">
          <h3 class="panel-title">
            <strong>{{propertydata.name}}</strong>
          </h3>
        </div>
      </div>

      <form class="form-horizontal">
        <div class="box-footer">
          <button
            id="cmdCancel"
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelPropertyList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{$t('common.back')}}
          </button>
          <button
            id="cmdPrintPdf"
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="printPdf"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-print"></i>
            </span>
            {{$t('common.printPdf')}}
          </button>
        </div>
      </form>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import config from "../../../build/config"
import configuration from "@/lib/config";
// import utils from '@/lib/utils'

export default {
  name: "PropertyPdf",
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      actionType: "",
      timeCurrent: "2019-01-16T06:00:00Z",
      propertys: [{ text: "Select One", value: null }],
      propertySelected: null,
      pagetitle: "Add New Asset",
      noqrcode: "noqrcode.png",
      show: false,
      propertydata: {
        id: 0,
        name: "",
        type: 1,
        price: 0,
        price_depreciation: 0
      }
    };
  },

  watch: {
    // watch customer detail
    PROPERTY_DETAIL_DATA: function() {
      this.propertydata.name = this.PROPERTY_DETAIL_DATA.name;
      this.propertydata.type = this.PROPERTY_DETAIL_DATA.property_type;
      this.propertydata.price = this.PROPERTY_DETAIL_DATA.price;
      this.propertydata.price_depreciation = this.PROPERTY_DETAIL_DATA.price_depreciation;
    }
  },
  computed: {
    imageSrc: function() {
      let qrcode = this.noqrcode;
      var url = "/media/QRCode/";
      if (this.propertydata.id != 0) {
        qrcode = this.propertydata.id + ".png";
        url += "property/";
      }
      let backendURL = config.BACKEND_URL;
      return backendURL + url + qrcode;
    },
    ...mapGetters([
      "GET_SNACK_BAR",
      "PROPERTY_DETAIL_DATA",
      "GET_PROPERTY_TYPE_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_PROPERTY_DETAIL",
      "GET_PROPERTY_TYPE_LIST"
    ]),
    printPdf: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },
    CancelPropertyList: function() {
      this.$router.push({
        name: "PropertyList"
      });
    }
  },
  mounted() {
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.propertydata.id = id;
      this.pagetitle = "Edit Property";
      this.GET_PROPERTY_DETAIL({ id: id });
      this.show = true;
    } else {
      //
    }

    this.GET_PROPERTY_TYPE_LIST().then(
      function(res) {
        let result = res.data;
        result.results.forEach(v => {
          let data = {
            text: v.name,
            value: v.id
          };
          this.propertys.push(data);
        });
      }.bind(this)
    );
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}
.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/PropertyPdf.vue